import { Component, Input } from '@angular/core';

@Component({
  selector: 'mood-admin-config-fieldset',
  templateUrl: './config-fieldset.component.html',
  styleUrls: [
    'config-fieldset.component.scss'
  ]
})
export class ConfigFieldsetComponent {
  @Input() legendTitle!: string;

  public expanded = false;
}
